import moment from 'moment'

// export store with auto season switch
let currentYear = moment().year()
let season = (moment().isBetween(`${currentYear}-04-02`, `${currentYear}-10-31`)) ? 'sommer' : 'winter'

export default {
	bookmarks: [],
	bonusCategories: [],
	cardinfos: [],
	cards: [],
	categories: [],
	companies: [],
	criterias: [],
	language: 'de',
	news: [],
	season: season,
	salespoints: [],
	likedCompanies: [],
	currentPosition: {
		lat: 46.728684,
		lng: 13.8505722
	},
	selectedService: 'home',
	browser: undefined,
	shopLink: {
		sommer: {
			weekCardLink: 'https://card-webshop.feratel.com/kcs01/web002/index.jsp', // ALT: https://card.feratel.com/cardwebshop2/kcs01/web002/index.jsp
			seasonCardLink: 'https://card-webshop.feratel.com/kcs01/default/index.jsp?mode=mycard' // ALT: https://card.feratel.com/cardwebshop2/kcs01/default/index.jsp?mode=mycard
		},
		winter: {
			weekCardLink: 'https://card-webshop.feratel.com/kcs01/winter002/index.jsp', // ALT: https://card.feratel.com/cardwebshop2/kcs01/winter002/index.jsp
			seasonCardLink: 'https://card-webshop.feratel.com/kcs01/winter/index.jsp?mode=mycard' // ALT: https://card.feratel.com/cardwebshop2/kcs01/winter/index.jsp?mode=mycard
		}
	},
	activeFilters: {
		companies: {
			results: [],
			resultsCount: 0,
			selectedRange: 150,
			selectedCategories: [],
			selectedCriterias: [],
			onlyTopPerformance: false
		},
		bonusClub: {
			results: [],
			resultsCount: 0,
			selectedRange: 150,
			selectedCategories: [],
			selectedCriterias: [],
			onlyTopPerformance: false
		},
		salespoints: {
			results: [],
			resultsCount: 0,
			selectedRange: 150
		}
	},
	lastEntity: 'companies',
	lastSalesEntity: 'week-cards',
	lastSeasonEntity: 'delivery-points',
	lastViewedCard: 0,	// Otti: Welche Karte wurde zuletzt angesehen
}